import React, { useEffect } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'
import { ButtonSizeTP } from 'submodules/nerit-framework-ui/common/components/button/inner/ButtonSizeTP'
import { ButtonTypeTP } from 'submodules/nerit-framework-ui/common/components/button/inner/ButtonTypeTP'

interface ICPProps {
	requestConfigTP: () => RequestConfigTP
	onSuccess: () => void
    appearance: {
        size?: ButtonSizeTP
        label?: string
        icon?: string
        type?: ButtonTypeTP
        hideIcon?: boolean
    }
    messages?: {
        confirmMessage?: string
        successMessage?: string
        errorMessage?: string
    }
}

/**
 * Botão genérico para executar requisições com confirmação.
 */
export function ButtonRequestCP(props: ICPProps): JSX.Element {
	const request = useRequest<void>('none')
	useEffect(onRequestChange, [request.isAwaiting])

	/**
	 * Executar requisição
	 */
	function executeRequest(): void {
		request.runRequest(props.requestConfigTP())
	}

	/**
	 * Retorno da requisição.
	 */
	function onRequestChange(): void {
		if (
			!RequestUtils.isValidRequestReturn(
				request,
				props.messages?.errorMessage ?? NotificationHelper.DEFAULT_ERROR_DELETE_MESSAGE,
				props.messages?.successMessage ?? NotificationHelper.DEFAULT_SUCCESS_DELETE_MESSAGE,
				true,
			)
		)
			return

		props.onSuccess()
	}

	return (
		<ButtonCP
			size={props.appearance?.size ?? 'small'}
			type={props.appearance?.type ?? 'default'}
			icon={props.appearance?.hideIcon ? undefined : (props.appearance?.icon ?? 'setting')}
			confirmMsg={props.messages?.confirmMessage ?? NotificationHelper.DEFAULT_CONFIRM_DELETE_MESSAGE}
			onClick={executeRequest}
			loading={request.isAwaiting}
		>
            {props.appearance?.label}
        </ButtonCP>
	)
} 